

(function(){
    angular.module('app.widgets')
        .directive('owlCarousel', owlCarousel)
        .directive('owlCarouselItem', owlCarouselItem);

  
        function owlCarousel () {
            return {
                restrict: 'E',
                transclude: false,
                link: function (scope) {
                    scope.initCarousel = function(element) {
                      // provide any default options you want
                        var defaultOptions = {
                        };
                        var customOptions = scope.$eval($(element).attr('data-options'));
                        // combine the two options objects
                        for(var key in customOptions) {
                            defaultOptions[key] = customOptions[key];
                        }
                        // init carousel
                        $(element).owlCarousel(defaultOptions);
                    };
                }
            };
        }
        function owlCarouselItem () {
            return {
                restrict: 'A',
                transclude: false,
                link: function(scope, element) {
                  // wait for the last item in the ng-repeat then call init
                    if(scope.$last) {
                        scope.initCarousel(element.parent());
                    }
                }
            };
        }

})();



/*****************
 ** WEBPACK FOOTER
 ** ./app/widgets/owl.carousel.directive.js
 ** module id = 199
 ** module chunks = 0
 **/